import { apiClient } from './api'
export interface AccountSecurityInfo { email: string; organizationCount: number; canChangePassword: boolean }
export const accountSecurityService = {
  info: async (): Promise<AccountSecurityInfo> => (await apiClient.get('/api/auth/account-security')).data,
  change: async (currentPassword: string, newPassword: string): Promise<{ notificationSent: boolean }> =>
    (await apiClient.post('/api/auth/change-password', { currentPassword, newPassword })).data,
}
